export const HEADER_PORTAL_ID = 'header-portal';
export const MAIN_CONTENT_ID = 'main-content';
